import yup from "src/validators/yup.Module";
import { isCteComplementoValores, validarChaveCTe } from "../CTe.Dto";

export const CaracteristicasSchema = yup.object().shape({
  tipoCte: yup.number().required("Tipo de CT-e é obrigatório"),
  tipoServico: yup.number().required("Tipo de serviço é obrigatório"),
  finalidadeCte: yup.number().required("Finalidade é obrigatória"),
  modal: yup.number().required("Modal é obrigatório"),
  retira: yup.number().required("Opção retira é obrigatória"),
  tipoTomador: yup.number().required("Tipo de tomador é obrigatório"),
  chaveCTeComplementado: yup
    .string()
    .nullable()
    .notRequired()
    .when("tipoCte", {
      is: (v: number) => isCteComplementoValores(v),
      then: (schema) =>
        schema.test("chave-cte", function (value) {
          const erro = validarChaveCTe(value);
          return erro ? this.createError({ message: erro }) : true;
        }),
    }),
  rntrc: yup
    .string()
    .nullable()
    .when("tipoCte", {
      is: (v: number) => isCteComplementoValores(v),
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required("RNTRC é obrigatório").min(1, "RNTRC é obrigatório"),
    }),
});

export type CaracteristicasFormType = yup.InferType<typeof CaracteristicasSchema>;

export const PercursoSchema = yup.object().shape({
  codigoMunicipioInicio: yup
    .number()
    .required("Município de início é obrigatório")
    .min(1, "Município de início é obrigatório"),
  nomeMunicipioInicio: yup
    .string()
    .required("Nome do município de início é obrigatório"),
  ufInicio: yup
    .string()
    .required("UF de início é obrigatória")
    .length(2, "UF deve ter 2 caracteres"),
  codigoMunicipioFim: yup
    .number()
    .required("Município de fim é obrigatório")
    .min(1, "Município de fim é obrigatório"),
  nomeMunicipioFim: yup
    .string()
    .required("Nome do município de fim é obrigatório"),
  ufFim: yup
    .string()
    .required("UF de fim é obrigatória")
    .length(2, "UF deve ter 2 caracteres"),
});

export type PercursoFormType = yup.InferType<typeof PercursoSchema>;

export const RemetenteSchema = yup.object().shape({
  documento: yup.string().required("Documento é obrigatório"),
  nome: yup.string().required("Nome/Razão Social é obrigatório"),
  nomeFantasia: yup.string().notRequired(),
  inscricaoEstadual: yup.string().notRequired(),
  endereco: yup.string().required("Endereço é obrigatório"),
  enderecoNumero: yup.string().required("Número é obrigatório"),
  bairro: yup.string().required("Bairro é obrigatório"),
  codigoMunicipio: yup.string().required("Município é obrigatório"),
  nomeMunicipio: yup.string().required("Nome do município é obrigatório"),
  uf: yup.string().required("UF é obrigatória"),
  cep: yup.string().required("CEP é obrigatório"),
  codigoPais: yup.string().notRequired(),
  nomePais: yup.string().notRequired(),
});

export type RemetenteFormType = yup.InferType<typeof RemetenteSchema>;

export const DestinatarioSchema = yup.object().shape({
  documento: yup.string().required("Documento é obrigatório"),
  nome: yup.string().required("Nome/Razão Social é obrigatório"),
  inscricaoEstadual: yup.string().notRequired(),
  indicadorIETomador: yup
    .number()
    .required("Indicador IE do Tomador é obrigatório"),
  fone: yup.string().notRequired(),
  endereco: yup.string().required("Endereço é obrigatório"),
  enderecoNumero: yup.string().required("Número é obrigatório"),
  bairro: yup.string().required("Bairro é obrigatório"),
  codigoMunicipio: yup.string().required("Município é obrigatório"),
  nomeMunicipio: yup.string().required("Nome do município é obrigatório"),
  uf: yup.string().required("UF é obrigatória"),
  cep: yup.string().required("CEP é obrigatório"),
  codigoPais: yup.string().notRequired(),
  nomePais: yup.string().notRequired(),
});

export type DestinatarioFormType = yup.InferType<typeof DestinatarioSchema>;

export const CargaSchema = yup.object().shape({
  valorCarga: yup
    .number()
    .required("Valor da carga é obrigatório")
    .min(0, "Valor deve ser maior ou igual a zero"),
  produtoPredominante: yup
    .string()
    .required("Produto predominante é obrigatório"),
  outraCaracteristica: yup.string().notRequired(),
  quantidades: yup
    .array()
    .of(
      yup.object().shape({
        codigoUnidadeMedida: yup
          .string()
          .required("Unidade de medida é obrigatória"),
        tipoMedida: yup.string().required("Tipo de medida é obrigatório"),
        quantidadeCarga: yup
          .number()
          .required("Quantidade é obrigatória")
          .min(0.001, "Quantidade deve ser maior que zero"),
      })
    )
    .required("Informe ao menos uma quantidade")
    .min(1, "Informe ao menos uma quantidade"),
});

export type CargaFormType = yup.InferType<typeof CargaSchema>;

export const ValoresSchema = yup.object().shape({
  valorPrestacaoServico: yup
    .number()
    .required("Valor da prestação é obrigatório")
    .min(0, "Valor deve ser maior ou igual a zero"),
  valorReceber: yup
    .number()
    .required("Valor a receber é obrigatório")
    .min(0, "Valor deve ser maior ou igual a zero")
    .max(
      yup.ref("valorPrestacaoServico"),
      "Valor a receber deve ser menor ou igual Valor da Prestação"
    ),
  valorTotalTributos: yup
    .number()
    .required("Valor total dos tributos é obrigatório")
    .min(0, "Valor deve ser maior ou igual a zero"),
  componentes: yup
    .array()
    .of(
      yup.object().shape({
        nome: yup.string().required("Nome do componente é obrigatório"),
        valor: yup
          .number()
          .required("Valor do componente é obrigatório")
          .min(0, "Valor deve ser maior ou igual a zero"),
      })
    )
    .required("Informe ao menos um componente da prestação")
    .min(1, "Informe ao menos um componente da prestação"),
});

export type ValoresFormType = yup.InferType<typeof ValoresSchema>;

export const DocumentosSchema = yup.object().shape({
  documentos: yup
    .array()
    .of(
      yup.object().shape({
        tipoDocumento: yup
          .number()
          .required("Tipo do documento é obrigatório"),
        chaveDocumento: yup
          .string()
          .required("Chave do documento é obrigatória")
          .length(44, "A chave deve conter exatamente 44 dígitos"),
      })
    )
    .required("Informe ao menos um documento originário")
    .min(1, "Informe ao menos um documento originário"),
});

export type DocumentosFormType = yup.InferType<typeof DocumentosSchema>;

export const FinalizacaoSchema = yup.object().shape({
  emissaoDataHora: yup.string().required("Data de emissão é obrigatória"),
  serie: yup.number().nullable().notRequired(),
  numeroCte: yup
    .number()
    .nullable()
    .notRequired()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || isNaN(value)
        ? null
        : value
    )
    .min(0, "O número do CT-e deve ser maior ou igual a zero"),
  observacao: yup.string().nullable().notRequired(),
});

export type FinalizacaoFormType = yup.InferType<typeof FinalizacaoSchema>;
